import { render, staticRenderFns } from "./nutrition-step-three.html?vue&type=template&id=74894336&scoped=true&"
import script from "./nutrition-step-three.js?vue&type=script&lang=js&"
export * from "./nutrition-step-three.js?vue&type=script&lang=js&"
import style0 from "./nutrition-step-three.scss?vue&type=style&index=0&id=74894336&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74894336",
  null
  
)

export default component.exports